export default "__VITE_ASSET__EeTUYjp9__"